import { dateJpTextFormat, dateFromUnix, dateEnFormat } from '../commonUtil';

const dataTransform = {
  methods: {
    fullStringDate(string) {
      if (!string || string.length < 1) return '';
      const time = dateFromUnix(string);
      const timeLabel = dateJpTextFormat(time);
      return timeLabel;
    },
    formatPrice(price, fractionDigits = 6) {
      return parseFloat(parseFloat(Number(price)).toFixed(fractionDigits)) || '0';
    },
    formatEnDate(string) {
      if (!string || string.length < 1) return '';
      const time = dateFromUnix(string);
      const timeLabel = dateEnFormat(time);
      return timeLabel;
    },
    formatEnStringDate(string) {
      if (!string || string.length < 1) return '';
      const time = new Date(string);
      const timeLabel = dateEnFormat(time);
      return timeLabel;
    }
  }
};

export default dataTransform;
